import React, { memo } from 'react'
import { Typography } from 'transfix-ui/core'
import { IVersion } from 'types/logs'
import { formatLogsTimestamp } from 'utils/formatDatetime'
import { DISPLAY } from 'constants/display'

interface IUpdatedCellProps {
  version: IVersion
  condensed: boolean
}

export const UpdatedCell = memo<IUpdatedCellProps>(({ condensed, version }) => (
  <div>
    {condensed && (
      <Typography color='textSecondary' variant='caption'>
        {formatLogsTimestamp(version.occurredAt)}
      </Typography>
    )}
    <Typography variant='body2'>
      {version.author && 'fullName' in version.author ? version.author.fullName : DISPLAY.botName}
    </Typography>
  </div>
))
